import type { TkDict } from "./types";

const dict: TkDict = {
  uz: {
    "tk.auth.title_a": "Kabinetga",
    "tk.auth.title_em": "kirish",
    "tk.auth.lead": "Taklifnomalaringizni boshqarish uchun hisobingizga kiring — parol shart emas.",
    "tk.auth.to_cabinet": "Kabinetga o'tish",
    "tk.auth.redirecting": "Yo'naltirilmoqda…",
    "tk.auth.otp_digit": "{n}-raqam",
    "tk.auth.inapp.open": "Brauzerda ochish",
    "tk.auth.inapp.copied": "Nusxa olindi",
  },
  ru: {
    "tk.auth.title_a": "Вход в",
    "tk.auth.title_em": "кабинет",
    "tk.auth.lead": "Войдите, чтобы управлять своими приглашениями, — пароль не нужен.",
    "tk.auth.to_cabinet": "Перейти в кабинет",
    "tk.auth.redirecting": "Перенаправляем…",
    "tk.auth.otp_digit": "Цифра {n}",
    "tk.auth.inapp.open": "Открыть в браузере",
    "tk.auth.inapp.copied": "Скопировано",
  },
  en: {
    "tk.auth.title_a": "Sign in to your",
    "tk.auth.title_em": "account",
    "tk.auth.lead": "Manage your invitations in one place — no password needed.",
    "tk.auth.to_cabinet": "Go to dashboard",
    "tk.auth.redirecting": "Redirecting…",
    "tk.auth.otp_digit": "Digit {n}",
    "tk.auth.inapp.open": "Open in browser",
    "tk.auth.inapp.copied": "Copied",
  },
};

export default dict;
